import { localized, msg } from "@lit/localize";
import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";
import "@whilecat/core/text/text-note.js";

@localized()
@customElement("placeholder-element")
export class PlaceholderElement extends LitElement {
    static styles = [
        css`
          :host {
            display: inline-flex;
          }

          .placeholder {
            font-family: monospace;
            padding-right: 3px;
            padding-left: 3px;
            border: 2px solid var(--whilecat-pink-2);
            border-bottom: none;
            border-top: none;
            border-radius: var(--sl-border-radius-medium);
            cursor: pointer;
            font-style: italic;
            color: var(--whilecat-pink-2);
            position: relative;
            display: inline-block;
          }

          .placeholder:hover {
            color: var(--whilecat-pink-3);
            border: 2px solid var(--whilecat-pink-3);
            border-bottom: none;
            border-top: none;
          }
        `,
    ];

    render() {
        return html`
            <div class="placeholder">${msg("Type here")}</div>
        `;
    }
}
